module.exports = __webpack_public_path__ + "media/src/assets/Images/Baths-c39eb83203a3c0dae987939d923348ba.svg";